import React, { useState, useEffect } from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Header from '../../Components/Header/Header';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';
import Chatbot from '../../Components/Chatbot/Chatbot';
import ScrollNav from '../../Components/ScrollNav/ScrollNav';
import { getAllVotesWithFilters } from '../../api/Vote';
import { getToken, getUserId } from '../../api/index';

const AddBallotPage = () => {
    const [sharedVotes, setSharedVotes] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    useEffect(() => {
        const fetchRightSectionVotes = async () => {
            try {
                const token = getToken();
                const userId = getUserId();
                if (!userId || !token) return;

                const response = await getAllVotesWithFilters({
                    userId: userId,
                    skip: 0,
                    take: 5
                }, token);

                setSharedVotes(response || []);
            } catch (error) {
                console.error("Error fetching votes for dashboard right section:", error);
            } finally {
                setIsInitialLoading(false);
            }
        };

        fetchRightSectionVotes();
    }, []);

    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <Chatbot isPageMode={true} />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection
                            initialVotes={sharedVotes}
                            isInitialLoading={isInitialLoading}
                        />
                    </div>
                </div>
                <ScrollNav />
            </div>
        </div>
    );
};

export default AddBallotPage;
